export const garmentTypesColumns = [
  { id: 'nombre', label: 'Nombre', type: 'text', sortable: true, required: true },
  { id: 'peso', label: 'Peso (g)', type: 'number', sortable: true, required: true },
  { id: 'precio', label: 'Precio', type: 'number', sortable: true, required: true },
  { id: 'descripcion', label: 'Descripción', type: 'textarea', sortable: false, required: false },
  { id: 'pax', label: 'Pax', type: 'select', sortable: true, required: true,
    options: [
      { value: 'Si', label: 'Sí' },
      { value: 'No', label: 'No' },
    ],
  },
 { id: 'basico', label: 'Basico', type: 'select', sortable: true, required: true,
    options: [
      { value: 'Si', label: 'Sí' },
      { value: 'No', label: 'No' },
    ],
  },
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ],
  },
];

export const columnsExcel = {
  nombre: 'Nombre',
  peso: 'Peso (kg)',
  precio: 'Precio',
  descripcion: 'Descripción',
  pax: 'Pax',
  basico: 'Basico',
  estado: 'Estado',
  createdAt: 'Fecha de Creación',
  updatedAt: 'Fecha de Actualización',
};
